var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FFE4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7246 5.10938L11.3916 5.77539L11.4502 5.83496L11.3916 5.89355L8.7832 8.50098L11.4502 11.168L10.666 11.9521L7.99902 9.28516L5.3916 11.8936L5.33301 11.9521L5.27344 11.8936L4.60742 11.2266L4.54785 11.168L4.60742 11.1094L7.21387 8.50098L4.60742 5.89355L4.54785 5.83496L5.33301 5.0498L5.3916 5.10938L7.99902 7.71582L10.6074 5.10938L10.666 5.0498L10.7246 5.10938Z",
    fill: "#D43939",
    stroke: "#D43939",
    strokeWidth: 0.166667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/Cancelled.72b23711bf3ae350cefcaf9abec0508a.svg";
export { ForwardRef as ReactComponent };